<template>
  <div class="news-sort">
    <header>
      <span class="title">新闻分类</span>
      <div class="right">
        <el-button type="primary" @click="dialogVisible = true" v-if="funAuth.includes(49)">新建分类</el-button>
      </div>
      <div class="tab-box">
        <div class="tab-item" :class="(sort_type === 1) ? 'active':''" @click="handleClick(1)">官网分类</div>
        <div class="tab-item" :class="(sort_type === 2) ? 'active':''" @click="handleClick(2)">定制网分类</div>
      </div>
    </header>
    <el-table :data='tableData' tooltip-effect='dark' style='width: 100%' class="el-table-01">
      <el-table-column
        prop="type_name"
        label="分类名称"
        width="293">
      </el-table-column>
      <el-table-column
        label="排序"
        width="227">
        <template slot-scope="scope">
          <i class="iconfont icon-jianjuxiao" @click="sort(scope.row.id,1,scope.row.sort)"></i>
          <i class="iconfont icon-jianjuda" @click="sort(scope.row.id,2,scope.row.sort)"></i>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <span class="operator-btn" @click="rename(scope.row.id,scope.row.type_name)" v-if="funAuth.includes(50)">重命名</span>
          <span class="operator-btn" @click="del(scope.row.id)" v-if="funAuth.includes(51)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="sort_type == 1?'官网分类名称':'定制网分类名称'"
      :visible.sync="dialogVisible"
      width="380px"
      @close="handleClose">
      <el-input v-model.trim="input" maxlength='6' placeholder="请输入"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addNew()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      moduleId: 15, // 模块ID
      sort_type: 1, // 1官网 2定制网
      currentId: '',
      dialogVisible: false,
      input: '',
      tableData: []
    }
  },
  mixins: [mixin],
  created () {
    this.getTypeList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
  },
  methods: {
    // 排序
    sort (id, direction, sort) {
      let obj = {
        'id': id,
        'source': this.sort_type,
        'sort': sort,
        'direction': direction // int 交换方向，1和前面的交换，2和后面的交换
      }
      this.$http.newsUpdateNewsTypeSort(obj).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.getTypeList()
      })
    },
    del (id) {
      this.$confirm('确定要删除该分类吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.newsDeleteNewsType({'id': id}).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.getTypeList()
        })
      })
    },
    handleClose () {
      this.input = ''
      this.currentId = ''
    },
    rename (id, typeName) {
      this.dialogVisible = true
      this.input = typeName
      this.currentId = id
    },
    // 新增新闻分类
    addNew () {
      if (this.input === '') {
        this.$message({
          showClose: true,
          message: '分类名称不能为空',
          type: 'error'
        })
        return
      }
      let obj = {
        type_name: this.input,
        source: this.sort_type
      }
      if (this.currentId) {
        obj.id = this.currentId
        delete obj['source']
        // 编辑
        this.$http.newsUpdateNewsType(obj).then(res => {
          this.dialogVisible = false
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success'
          })
          this.getTypeList()
        })
      } else {
        // 新增
        this.$http.newsAddNewsType(obj).then(res => {
          this.dialogVisible = false
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success'
          })
          this.getTypeList()
        })
      }
    },
    // 获取新闻分类
    getTypeList () {
      let obj = {'source': this.sort_type}
      this.$http.newsQueryNewType(obj).then(res => {
        this.tableData = res.dataList
      })
    },
    handleClick (tab) {
      this.sort_type = tab
      this.getTypeList()
    }
  }
}
</script>

<style lang="scss">
.news-sort{
  header{
    height: auto!important;
    .right{
      >span{
        margin: 0 12px;
      }
    }
    .tab-box{
      overflow: hidden;
      margin: 0 0 -1px 0;
      .tab-item{
        display: inline-block;
        float: left;
        width: 88px;
        height: 39px;
        text-align: center;
        line-height: 40px;
        background: #fff;
        border: 1px solid rgba(0,0,0,0.15);
        border-radius: 4px 4px 0 0;
        margin-right: 4px;
        border-bottom: none;
        cursor: pointer;
      }
      .tab-item.active{
        height: 40px;
        background: #FAFAFA;
        color: #0062B1;
        border: 1px solid #0062B1;
        border-bottom: 1px solid transparent;
      }
    }
  }
  .el-table{
    height: calc(100% - 160px);
    .icon-jianjuxiao,.icon-jianjuda {
      cursor: pointer;
      &:hover {
        color: #1890FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/news/news-sort.vue